const singleDataConfig = {
    Departments: {
        sfScreen: "Departments",
        sfHead: "Departments",
        heading: "Departments",
        fieldLabel: "Department Description",
    },
    ItemCategory: {
        sfScreen: "ItemsInformation",
        sfHead: "Category",
        heading: "Item Category",
        fieldLabel: "Item Category Description",
    },
    MillsRegistration: {
        sfScreen: "Mills",
        sfHead: "Mlls",
        heading: "Mills Registration",
        fieldLabel: "Mill Description",
    },
    UnitofMeasurement: {
        sfScreen: "UnitofMeasurement",
        sfHead: "UnitofMeasurement",
        heading: "Unit of Measurement",
        fieldLabel: "Unit of Measurement",
    },
    VariantSetup: {
        sfScreen: "VariantSetup",
        sfHead: "Variant",
        heading: "Variant Setup",
        fieldLabel: "Variant Name",
    },

};

export default singleDataConfig